import axios from 'axios';


const emailToMibao = async (body) => {
    const template = `
        <table>
            <tr>
                <td>姓名</td>
                <td>${body.name}</td>
            </tr>
            <tr>
                <td>電話</td>
                <td>${body.phone}</td>
            </tr>
            <tr>
                <td>地址</td>
                <td>${body.address}</td>
            </tr>
            <tr>
                <td>預產期</td>
                <td>${body.dueDate}</td>
            </tr>
            <tr>
                <td>參觀日期</td>
                <td>${body.appointmentDate}</td>
            </tr>
            <tr>
                <td>參觀時段</td>
                <td>${body.appointmentTime}</td>
            </tr>
            <tr>
                <td>預計入住天數</td>
                <td>${body.duration}</td>
            </tr>
            <tr>
                <td>致電時間</td>
                <td>${body.callbackTime}</td>
            </tr>
            <tr>
                <td>取得資訊</td>
                <td>${body.reference}</td>
            </tr>
            <tr>
                <td>備註</td>
                <td>${body.note}</td>
            </tr>
        </table>
    `;
    const response = await axios.post('http://127.0.0.1:5000/email/mibao', 
        { body, template },
        { headers: { 'Content-Type': 'application/json' }}
    )
    return response.data;
}

module.exports = {
    emailToMibao: emailToMibao
};



// WEBPACK FOOTER //
// ./src/client/services/emailService.js